// Q-Configurator Pro - Type Definitions and Helpers

// Drawer size configurations
export const DRAWER_CONFIGS = {
  small: { units: 1, label: 'Small (1 unit)', maxPerModule: 3 },
  medium: { units: 1.5, label: 'Medium (1.5 units)', maxPerModule: 2 },
  large: { units: 3, label: 'Large (3 units)', maxPerModule: 1 },
};

// Module color palette
export const MODULE_COLORS = [
  '#dc2626', // Red
  '#ea580c', // Orange
  '#ca8a04', // Yellow
  '#16a34a', // Green
  '#0891b2', // Cyan
  '#2563eb', // Blue
  '#7c3aed', // Purple
  '#db2777', // Pink
];

// Storage key for localStorage
export const STORAGE_KEY = 'qconfigurator_cabinet_state';

// Helper functions
export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const calculateUsedUnits = (drawers) => {
  if (!drawers || !Array.isArray(drawers)) return 0;
  return drawers.reduce((total, drawer) => total + (drawer.units || 0), 0);
};

export const getRemainingUnits = (drawers) => {
  return 3 - calculateUsedUnits(drawers);
};

export const canAddDrawer = (drawers, size) => {
  const remaining = getRemainingUnits(drawers || []);
  return remaining >= DRAWER_CONFIGS[size].units;
};

export const createEmptyModule = (name = 'New Module') => ({
  id: generateId(),
  name,
  maxUnits: 3,
  drawers: [],
  createdAt: new Date().toISOString(),
  color: MODULE_COLORS[Math.floor(Math.random() * MODULE_COLORS.length)],
});

export const createEmptyDrawer = (size, name = '') => ({
  id: generateId(),
  size,
  units: DRAWER_CONFIGS[size].units,
  name: name || `${size.charAt(0).toUpperCase() + size.slice(1)} Drawer`,
  image: null,
  items: [],
  createdAt: new Date().toISOString(),
});

export const createEmptyItem = (name = 'New Item') => ({
  id: generateId(),
  name,
  description: '',
  image: null,
  quantity: 1,
  createdAt: new Date().toISOString(),
});

export const calculateStatistics = (modules) => {
  let totalDrawers = 0;
  let totalItems = 0;
  const drawersBySize = { small: 0, medium: 0, large: 0 };
  let totalCapacityUsed = 0;

  modules.forEach(module => {
    module.drawers.forEach(drawer => {
      totalDrawers++;
      totalItems += drawer.items.length;
      drawersBySize[drawer.size]++;
      totalCapacityUsed += drawer.units;
    });
  });

  return {
    totalModules: modules.length,
    totalDrawers,
    totalItems,
    drawersBySize,
    averageItemsPerDrawer: totalDrawers > 0 ? totalItems / totalDrawers : 0,
    totalCapacityUsed,
    totalCapacityAvailable: modules.length * 3,
  };
};
